import React, { useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import Sidebar from '../components/Sidebar'; // adjust path

const BookTableWithSidebar = () => {
  const [loading, setLoading] = useState(true);

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: 250,
          bgcolor: '#1e1e1e',
          color: '#fff',
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Sidebar />
      </Box>

      {/* Main content */}
      <Box sx={{ flexGrow: 1, position: 'relative', overflow: 'hidden' }}>
        {/* Loader overlay */}
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255,255,255,0.8)',
              zIndex: 2,
            }}
          >
            <CircularProgress size={50} />
            <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
              Loading booking page...
            </Typography>
          </Box>
        )}

        {/* Iframe */}
        <iframe
          src="https://mveapi.momentsview.com/" // your BookTable route
          title="MVE API"
          onLoad={() => setLoading(false)} // hide loader when loaded
          style={{
            width: '99%',
            marginLeft:20,
            height: '100%',
            border: 'none',
            backgroundColor: '#fff',
          }}
        />
      </Box>
    </Box>
  );
};

export default BookTableWithSidebar;
